const state = {
  isRightSideBarShown: false,
  /* Left side bar variables */
  minimizedDrawer: false,
  openedDrawer: true,
  sideBarFullWidth: 300,
  sideBarMinimizedWidth: 70,
  /* Right side bar variables */
  minimizedRightDrawer: true,
  openedRightDrawer: true,
  rightSideBarFullWidth: 300,
  rightSideBarMinimizedWidth: 25
}

const mutations = {
  'SET_MINIMIZED_DRAWER' (state, value) {
    state.minimizedDrawer = value
  },
  'SET_OPENED_DRAWER' (state, value) {
    state.openedDrawer = value
  },
  'SET_MINIMIZED_RIGHT_DRAWER' (state, value) {
    state.minimizedRightDrawer = value
  },
  'SET_OPENED_RIGHT_DRAWER' (state, value) {
    state.openedRightDrawer = value
  },
  'SET_RIGHT_SIDE_BAR_STATUS' (state, value) {
    state.isRightSideBarShown = value
  }
}

const actions = {}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
